import { GameVars } from "./../GameVars";
import { GameConstants } from "../GameConstants";
import { AudioManager } from "./AudioManager";
import { Translation } from "../Translation";

export class GameManager {

    private static game: Phaser.Game;

    public static init(game: Phaser.Game): void {

        GameManager.game = game;
        GameManager.readGameData();
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    let userLang = GameConstants.LANG_EN;
                    if (GameConstants.USE_BROWSER_LANG_BY_DEFAULT) {
                        if ([
                            GameConstants.LANG_EN,
                            GameConstants.LANG_ES,
                            GameConstants.LANG_DE,
                            GameConstants.LANG_FR,
                            GameConstants.LANG_IT,
                            GameConstants.LANG_CA,
                            GameConstants.LANG_PT
                        ].some(l => l === window.navigator.language.substring(0, 2))) {
                            userLang = window.navigator.language.substring(0, 2);
                        }
                    }
                    GameVars.gameData = {
                        muted: false,
                        chips: 2000,
                        firstTime: true,
                        nextChipRechargeAt: 0,
                        language: userLang
                    };
                }
                GameManager.startGame();
            }
        );
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static onGameAssetsLoaded(): void {
        GameManager.correctUrl();
    }

    public static correctUrl(): void {
        GameVars.botsInfo = GameManager.game.cache.json.get("bots");

        GameVars.winners = {};
        GameVars.points = {};
        GameVars.winnerCount = 0;

        let keys = Object.keys(GameVars.botsInfo);
        for (let i = 0; i < keys.length; i++) {
            GameVars.winners[keys[i]] = 0;
            GameVars.points[keys[i]] = 0;
        }

        AudioManager.init();

        GameManager.enterSplashScene();
        // GameManager.enterHiLoScene();
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static enterRoomScene(): void {

        GameVars.initialChips = GameVars.gameData.chips - GameConstants.ROOM_PRICE;
        GameVars.gameData.firstTime = false;
        GameManager.writeGameData();

        GameVars.currentScene.scene.start("RoomScene");
    }

    public static enterHiLoScene(): void {

        GameVars.currentScene.scene.start("HiLoScene");
    }

    public static roomToSplash(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    private static startGame(): void {

        GameManager.game.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
